/**
 * A thin delegate. The route composition lives in `src/app/router.tsx` since T71 closed F-069.
 *
 * This file stays because `src/main.tsx` imports it and because the name is what every reader
 * looks for first; it holds no routing of its own. If you came here to add a route, the file you
 * want is `src/app/router.tsx`, and the answer is probably a feature's own `routes.tsx`.
 */
import { AppRouter } from '@/app/router';

function App() {
    return <AppRouter />;
}

export default App;
